export default __webpack_public_path__ + "static/media/bars-solid.56e63b6b.svg";